import { Text } from "@mantine/core";

import type { CustomerLoveMetricsView } from "../data/types";

import customerLoveIcon from "./assets/customerLoveIcon.png";
import styles from "./cardContent.module.css";
import { computeDirectRingFill, computeMetricStatus } from "./computeRingFill";
import { MetricCard } from "./MetricCard";
import { RingArt } from "./RingArt";
import { CUSTOMER_LOVE_ERP_TARGET, CUSTOMER_LOVE_NPS_TARGET, CUSTOMER_LOVE_GRADIENT } from "./targets";

interface Props {
    view: CustomerLoveMetricsView;
    metricType: "fiveStarRating" | "entireRepPerformance";
}

export function CustomerLoveCard({ view, metricType }: Props) {
    const rating = view.yesterdayRating;
    const hasRating = rating !== null;

    const isERP = metricType === "entireRepPerformance";
    const target = isERP ? CUSTOMER_LOVE_ERP_TARGET : CUSTOMER_LOVE_NPS_TARGET;
    const displayValue = isERP ? `${rating?.toFixed(1)}%` : rating?.toFixed(1);
    const displayTarget = isERP ? `${target}%` : target;

    const ringProgress = hasRating ? computeDirectRingFill(rating, target) : 0;
    const status = hasRating ? computeMetricStatus(ringProgress) : undefined;
    const delta = hasRating
        ? `${Math.abs(rating - target).toFixed(1)}${isERP ? "%" : ""} ${rating >= target ? "above" : "below"} target`
        : undefined;

    return (
        <MetricCard
            title="Customer love"
            isLoading={view.isLoading}
            isEmpty={!hasRating}
            emptyValue="No reviews yesterday."
            art={
                <RingArt progress={ringProgress} gradient={CUSTOMER_LOVE_GRADIENT} isLoading={view.isLoading}>
                    <img src={customerLoveIcon} alt="" className={styles.icon} />
                </RingArt>
            }
            value={
                <Text component="span" className={styles.bigNumber}>
                    {displayValue}
                </Text>
            }
            footer={<>{displayTarget} or higher</>}
            status={status}
            delta={delta}
        />
    );
}
